<template>
  <hel-module title="业务链群经营分析" :class="scope.clsPrefix" v-loading="loading">
    <div class="chain-analysis-container">
      <div class="analysis-header">
        <span class="analysis-period">{{ year }}年 · 目标收入、实际收入与完成率</span>
        <span class="analysis-unit">单位：万元</span>
      </div>
      <div class="chain-grid">
        <div
          class="chain-card"
          v-for="(item, index) in chainData"
          :key="index"
          @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = -1"
        >
          <div class="chain-header">
            <span class="chain-name">{{ item.name }}</span>
          </div>
          <div class="chain-owner">负责人：{{ item.owner }}</div>
          <div class="chain-metrics">
            <span class="chain-actual">实际 {{ item.actual }}</span>
            <span class="chain-target">/ 目标 {{ item.target }}</span>
          </div>
          <div class="chain-progress">
            <div class="progress-bar">
              <div
                class="progress-fill"
                :class="item.progressClass"
                :style="{ width: item.rate + '%' }"
              ></div>
            </div>
            <span class="chain-rate" :class="item.rateClass">{{ item.rate }}%</span>
          </div>
          <div class="chain-gap-detail">
            <span class="gap-label">差额</span>
            <span class="gap-value" :class="item.gapClass">{{ item.gap }}</span>
          </div>
          <div class="chain-mask" v-show="hoverIndex === index">
            <button class="smart-analysis-btn" @click.stop="handleSmartAnalysis(item)">
              智能分析
            </button>
          </div>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
export default {
  name: 'BusinessChainAnalysis',
  components: {
    HelModule
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-business-chain-analysis'
      },
      hoverIndex: -1,
      chainData: [],
      year: new Date().getFullYear().toString()
    }
  },
  created() {
    this.fetchChainData()
  },
  methods: {
    handleSmartAnalysis(item) {
      const content = `${item.name}，年累计实际收入${item.actual}，目标收入${item.target}，差额${item.gap}，完成率${item.rate}%，分析一下经营情况，评估经营风险。`
      this.$emit('smart-analysis', {
        type: 'businessChainAnalysis',
        content
      })
    },
    formatNum(value) {
      if (value == null || isNaN(value)) return '--'
      return Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },
    formatGap(value) {
      if (value == null || isNaN(value)) return '--'
      const num = Number(value)
      const prefix = num >= 0 ? '+' : ''
      return prefix + num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },
    getRateClass(rate) {
      if (rate >= 100) return { gapClass: 'gap-positive', progressClass: 'progress-exceed', rateClass: 'rate-exceed' }
      if (rate >= 85) return { gapClass: 'gap-negative', progressClass: 'progress-success', rateClass: 'rate-success' }
      if (rate >= 60) return { gapClass: 'gap-negative', progressClass: 'progress-warning', rateClass: 'rate-warning' }
      return { gapClass: 'gap-negative', progressClass: 'progress-danger', rateClass: 'rate-danger' }
    },
    async fetchChainData() {
      this.loading = true
      try {
        const year = new Date().getFullYear().toString()
        const response = await axios.post(
          'https://bigdata.cosmoplat.com/prod-api/system/api/call/chainGroupRevenue',
          { secret: '88py6X', paramList: [{ paramName: 'year', paramValue: year }] },
          { headers: { 'Content-Type': 'application/json' }}
        )
        const { data } = response.data
        if (data && data.length > 0) {
          this.chainData = data.map((item) => {
            const rate = Number(item.completion_rate) || 0
            const cls = this.getRateClass(rate)
            return {
              name: item.chain_group || '--',
              owner: item.leader || '--',
              actual: this.formatNum(item.actual),
              target: this.formatNum(item.target),
              rate,
              gap: this.formatGap(item.diff),
              gapClass: cls.gapClass,
              progressClass: cls.progressClass,
              rateClass: cls.rateClass
            }
          })
        }
      } catch (error) {
        console.error('获取业务链群经营分析失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-business-chain-analysis";
.#{$class-prefix} {
  .chain-analysis-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .analysis-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }
  .analysis-period {
    font-size: 12px;
    color: #666;
    font-weight: 400;
  }
  .analysis-unit {
    font-size: 12px;
    color: #999;
    font-weight: 400;
  }
  .chain-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    flex: 1;
    overflow-y: auto;
  }
  .chain-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 12px;
    position: relative;
    transition: all 0.3s ease;
    &:hover {
      border-color: #4a5ff3;
      box-shadow: 0 2px 8px rgba(74, 95, 243, 0.1);
    }
  }
  .chain-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(237, 241, 251, 0.23);
    backdrop-filter: blur(1px);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .smart-analysis-btn {
    width: 64px;
    height: 24px;
    border: none;
    background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 12px;
  }
  .chain-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }
  .chain-name {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  .chain-owner {
    font-size: 11px;
    color: #999;
    margin-bottom: 8px;
  }
  .chain-metrics {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin-bottom: 8px;
  }
  .chain-actual {
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
  .chain-target {
    font-size: 12px;
    color: #999;
  }
  .chain-progress {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }
  .progress-bar {
    flex: 1;
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
  }
  .progress-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
    &.progress-success {
      background: linear-gradient(90deg, #73b950, #5cb85c);
    }
    &.progress-warning {
      background: linear-gradient(90deg, #f4b13d, #f0ad4e);
    }
    &.progress-danger {
      background: linear-gradient(90deg, #f44f4f, #e74c3c);
    }
    &.progress-exceed {
      background: linear-gradient(90deg, #73b950, #27ae60);
    }
  }
  .chain-rate {
    font-size: 14px;
    font-weight: 700;
    min-width: 40px;
    text-align: right;
    &.rate-success {
      color: #73b950;
    }
    &.rate-warning {
      color: #f4b13d;
    }
    &.rate-danger {
      color: #f44f4f;
    }
    &.rate-exceed {
      color: #73b950;
    }
  }
  .chain-gap-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .gap-label {
    font-size: 11px;
    color: #999;
  }
  .gap-value {
    font-size: 12px;
    font-weight: 600;
    &.gap-positive {
      color: #73b950;
    }
    &.gap-negative {
      color: #f44f4f;
    }
  }
}
</style>
